// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".top1{width:90%}.dataShow,.top1{display:flex;flex-direction:row;justify-content:space-between}.dataShow{width:70%;font-size:15px;margin-bottom:30px;@include change_size($font_size_normal)}.data{color:#409eff;height:50px;line-height:22px}.con{display:flex;height:25px;@include change_size($font_size_normal)}", ""]);
// Exports
module.exports = exports;
